import { Component, Input, OnInit } from '@angular/core';
import { AppointmentService } from '../appointment.service';
import { StringUtil } from 'src/app/common/utils/string.util';
import { PatientService } from 'src/app/patient/patient.service';
import { DatePipe } from '@angular/common';
import { UserService } from 'src/app/user/user.service';
import { Constants } from 'src/app/app.constants';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
    selector: 'app-appt-completion',
    templateUrl: './app-completion.component.html'
})
export class AppointmentCompletionComponent implements OnInit {
    public notes: string;
    public appt: any = {};
    public sessionDetails: any = [];
    @Input() public appointmentId;
    @Input() public s_id: any;

    constructor(
        private appointmentServie: AppointmentService,
        public activeModal: NgbActiveModal,
        private modalService: NgbModal,
        private patientservice: PatientService,
        private userService: UserService,
        private datepipe: DatePipe
    ) { }

    ngOnInit(): void {
        if (this.s_id != undefined && this.s_id != 0) {
            this.sessionDuration();
        }
        if (this.appointmentId > 0) {
            this.appointmentServie.getAppointment(this.appointmentId).subscribe((appt: any) => {
                if (appt) {
                    this.appt = appt;
                    this.appt.apptTime = new Date(StringUtil.replaceAll(appt.appointmentDt + ' ' + appt.startTime, '-', '/'));
                }
            });
        }
    }

    sessionDuration() {
        const date = this.datepipe.transform(new Date(), 'yyyy-MM-ddTHH:mm');
        const appointmentId = this.userService.appointmentId;
        this.patientservice.getSessionDurationDetails(this.s_id, date, appointmentId).subscribe((info: any) => {
            const tempstarttime = new Date(info.startTime).toLocaleString('en-US');
            info.startTime = new Date(tempstarttime + ' UTC');
            const tempendtime = new Date(info.endTime).toLocaleString('en-US');
            info.endTime = new Date(tempendtime + ' UTC');
            this.sessionDetails = info;
        });
    }

    public complete() {
        const appt: any = {};
        appt.appointmentId = this.appointmentId;
        appt.notes = this.notes;
        this.appointmentServie.completeAppointment(appt).subscribe(() => {
            this.closeModal();
            window.location.replace('/app/dashboard/clinician');
        });
    }
    // closePopup
    closeModal() {
        this.activeModal.close();
    }
}
